module.exports = __webpack_public_path__ + "img/discover.e88f74a2.png";